import { ErrorContext } from "../contexts/errorHandler";
import { useContext } from "react";

export const useErrorHandler = () => {
  const { errorHandler, notify, localErrors, dismissError } =
    useContext(ErrorContext);
  return { errorHandler, notify, localErrors, dismissError };
};
